import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart } from "@fortawesome/free-solid-svg-icons";

// Array of premium gradients to assign to project cards
const gradients = [
  "linear-gradient(135deg, #4f5b93 0%, #9ba3eb 100%)", // Indigo / Lavender
  "linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)", // Deep Blue
  "linear-gradient(135deg, #0ba360 0%, #3cba92 100%)", // Green Teal
  "linear-gradient(135deg, #e65c00 0%, #F9D423 100%)", // Orange / Gold
  "linear-gradient(135deg, #d3cbb8 0%, #6d6046 100%)", // Muted Bronze
  "linear-gradient(135deg, #8a2387 0%, #e94057 100%, #f27121 100%)", // Sunset Pink
];

const ProjectCard = ({ project, index, onClick }) => {
  const [isLiked, setIsLiked] = useState(false);

  // Assign a gradient based on the index
  const cardGradient = gradients[index % gradients.length];

  const handleLikeClick = (e) => {
    e.stopPropagation(); // Prevent opening the modal
    setIsLiked(!isLiked);
  };

  const handleCardClick = (e) => {
    console.log("Card container clicked for project:", project.title);
    if (onClick) onClick();
  };

  const handleButtonClick = (e) => {
    e.stopPropagation(); // Stop bubbling to prevent double triggering
    console.log("View details button clicked for project:", project.title);
    if (onClick) onClick();
  };

  return (
    <div
      className="project-card modular-card"
      onClick={handleCardClick}
      style={{ "--card-index": index }}
    >
      {/* Top Half: Image Container with Gradient */}
      <div className="project-card-image-wrapper" style={{ background: cardGradient }}>
        <img
          src={project.image}
          alt={project.title}
          className="project-card-image"
          onError={(e) => {
            // Fallback image if the local placeholder is missing or fails to load
            e.target.src = "https://images.unsplash.com/photo-1555066931-4365d14bab8c?w=500&auto=format&fit=crop&q=60";
          }}
        />
        {/* Floating Heart / Like Button */}
        <button
          className={`project-card-like-btn ${isLiked ? "liked" : ""}`}
          onClick={handleLikeClick}
          aria-label="Like project"
        >
          <FontAwesomeIcon icon={faHeart} />
        </button>
      </div>

      {/* Bottom Half: White Info Area */}
      <div className="project-card-info">
        <h4 className="project-card-title">{project.title}</h4>
        
        <div className="project-languages">
          {project.languages &&
            project.languages.slice(0, 2).map((lang, i) => (
              <span key={i} className="language-tag outline-badge">
                {lang}
              </span>
            ))}
          {project.languages && project.languages.length > 2 && (
            <span className="language-tag-more outline-badge">
              +{project.languages.length - 2}
            </span>
          )}
        </div>

        <p className="project-card-desc-snippet">{project.description}</p>
        
        {/* Footer Row matching Nike Price/Button section */}
        <div className="project-card-footer">
          <div className="project-category-info">
            <span className="project-category-label">Category</span>
            <span className="project-category-val">{project.category || "Web App"}</span>
          </div>
          <button className="project-view-btn" onClick={handleButtonClick}>
            View Details
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProjectCard;
